import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: '#0066cc',
          light: '#3385d6',
          dark: '#004d99',
          contrastText: '#ffffff'
        },
        secondary: {
          main: '#00d4aa',
          light: '#33dcbb',
          dark: '#00a085',
          contrastText: '#000000'
        },
        background: {
          default: '#f7fafc',
          paper: '#ffffff'
        },
        text: {
          primary: '#1a1a1a',
          secondary: '#718096'
        },
        grey: {
          50: '#f7fafc',
          100: '#e2e8f0',
          200: '#cbd5e0',
          300: '#a0aec0',
          400: '#718096',
          500: '#4a5568',
          600: '#2d3748',
          700: '#1a202c',
          800: '#171923',
          900: '#1a1a1a'
        },
        success: {
          main: '#00b894',
          contrastText: '#ffffff'
        }
      }
    },
    dark: {
      palette: {
        primary: {
          main: '#0066cc',
          light: '#3385d6',
          dark: '#004d99',
          contrastText: '#ffffff'
        },
        secondary: {
          main: '#00d4aa',
          light: '#33dcbb',
          dark: '#00a085',
          contrastText: '#000000'
        },
        background: {
          default: '#1a1a1a',
          paper: '#2d3748'
        },
        text: {
          primary: '#f7fafc',
          secondary: '#a0aec0'
        },
        grey: {
          50: '#1a1a1a',
          100: '#171923',
          200: '#1a202c',
          300: '#2d3748',
          400: '#4a5568',
          500: '#718096',
          600: '#a0aec0',
          700: '#cbd5e0',
          800: '#e2e8f0',
          900: '#f7fafc'
        },
        success: {
          main: '#00b894',
          contrastText: '#ffffff'
        }
      }
    }
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Space Grotesk", "Inter", sans-serif',
      fontWeight: 700,
      fontSize: '3.5rem',
      lineHeight: 1.2
    },
    h2: {
      fontFamily: '"Space Grotesk", "Inter", sans-serif',
      fontWeight: 600,
      fontSize: '2.5rem',
      lineHeight: 1.3
    },
    h3: {
      fontFamily: '"Space Grotesk", "Inter", sans-serif',
      fontWeight: 600,
      fontSize: '2rem',
      lineHeight: 1.4
    },
    h4: {
      fontFamily: '"Space Grotesk", "Inter", sans-serif',
      fontWeight: 500,
      fontSize: '1.5rem',
      lineHeight: 1.4
    },
    h5: {
      fontFamily: '"Space Grotesk", "Inter", sans-serif',
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: 1.5
    },
    h6: {
      fontFamily: '"Space Grotesk", "Inter", sans-serif',
      fontWeight: 500,
      fontSize: '1rem',
      lineHeight: 1.5
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6
    }
  },
  shape: {
    borderRadius: 12
  }
});

export default theme;